exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".design-svg[data-v-cb5cdc42]{display:block;max-height:500px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.design-block[data-v-cb5cdc42]{stroke:#333;stroke-width:.15}.design-block path.sp-path[data-v-cb5cdc42]{stroke:#333;stroke-width:.3}.active-color .design-block[data-v-cb5cdc42],.active-custom-block .design-block[data-v-cb5cdc42],.active-rotate .design-block[data-v-cb5cdc42]{cursor:pointer}.design-border[data-v-cb5cdc42]{fill:none;stroke:#333;stroke-width:.3;pointer-events:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-cb5cdc42","scoped":true,"hasInlineConfig":false}!./~/postcss-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/client/components/DesignView.vue
// module id = 533
// module chunks = 1